import { FC } from 'react';
import { Modal, Button } from '@marriott/mi-ui-library';
import { SessionTimeoutModalProps } from './SessionTimeoutModal.types';
import { StyledSessionTimeoutModal } from './SessionTimeoutModal.styles';

export const SessionTimeoutModal: FC<SessionTimeoutModalProps> = props => {
    const { show, onClose, heading, description, continue: continueText, continueAriaLabel, sessionTrackLocation, sessionTrackDescription } = props;

    return (
        <StyledSessionTimeoutModal>
            <Modal
                modalId="session-timeout-modal"
                role="dialog"
                labelledBy="session-timeout-heading"
                secondaryClassName="session-timeout-modal"
                show={show}
                popupOpenState={show}
                handleBlur={true}
                disableScrollOnBody={true}
                setPopupOpenState={onClose}
                onClose={onClose}
            >
                <Modal.Header
                    labelText={heading}
                    popupHeaderOnCLoseFunc={onClose}
                    closeIconClickTrackValue={`${sessionTrackLocation} | Close Button | internal`}
                />
                <Modal.Body className="pb-5 pr-5">
                    <div className="modal-content">
                        <p className="description">{description}</p>
                        <Button
                            callback={onClose}
                            buttonCopy={continueText}
                            className="m-button-primary custom_click_track"
                            ariaLabel={continueAriaLabel}
                            custom_click_track_value={`${sessionTrackLocation}|${sessionTrackDescription}|internal`}
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </StyledSessionTimeoutModal>
    );
};
